// const baseUrl = 'http://localhost:8000';
const baseUrl = "https://portfolio-backend-v1.herokuapp.com";

export default baseUrl;
